module.exports = __webpack_public_path__ + "static/media/HEART-7.670aa792.svg";